import React, { useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import ExportVodForm from '../MediaLibrary/NodeTreeView/ExportVodForm';
import { PUBLISH_REPORT, PUBLISH_TYPE } from '../../framework/constant/constant';

const VodCatalogueExportCollection = () => {

  const lang = useTranslation();
  const [footerMessage, setFooterMessage] = useState('');

  const borderStyle = {
    border: "1px solid #ced4da",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#FAFAFA"
  }

  return (
    <div className='m-1'>
      <h1 className="page-title txt-color-bludeDark">
        <i className="fa fa-table marlr" style={{ fontSize: 20, color: 'GrayText' }} />
        <span>{lang.vod_catalogue_page_breadcrumb}</span>
      </h1>
      <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
        <ExportVodForm publishReport={PUBLISH_REPORT.VOD_CATALOGUE} setFooterMessage={setFooterMessage} />
        <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
      </div>
    </div>
  )
}

export default VodCatalogueExportCollection